import React, { useState, useEffect } from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import "./header.css";

const Header = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 30);
    };

    window.addEventListener("scroll", onScroll);

    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <Navbar
      expand="lg"
      fixed="top"
      className={`portfolio-navbar ${scrolled ? "scrolled" : ""}`}
      variant="dark"
    >
      <Container>

        <Navbar.Brand href="#about" className="brand-name">
          Putha P L Narasimha Rao
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="portfolio-navbar" />

        <Navbar.Collapse id="portfolio-navbar">

          <Nav className="ms-auto">

            <Nav.Link href="#about">
              About
            </Nav.Link>

            <Nav.Link href="#achievements">
              Achievements
            </Nav.Link>

            <Nav.Link href="#experience">
              Experience
            </Nav.Link>
            
            <Nav.Link href="#skills">
              Skills
            </Nav.Link>

            <Nav.Link href="#projects">
              Projects
            </Nav.Link>


            <Nav.Link href="#contact">
              Contact
            </Nav.Link>

          </Nav>

        </Navbar.Collapse>

      </Container>
    </Navbar>
  );
};

export default Header;